<app-headerfour></app-headerfour>
<!-- <app-headerinner></app-headerinner> -->
<app-breadcrumb></app-breadcrumb>
<!-- Menu Categories Start -->
<div class="ct-menu-categories menu-filter">
    <div class="container">
        <ngx-slick-carousel #slickModal="slick-carousel" [config]="settings" class="menu-category-slider">
    <a href="javascript:void(0)" 
       (click)="reset()" 
       class="ct-menu-category-item" 
       [class.active]="!selectedCategory">
        <div class="menu-category-thumb">
            <img src="assets/img/categories/6.jpg" alt="category">
        </div>
        <div class="menu-category-desc">
            <h6>All</h6>
        </div>
    </a>
    <a href="javascript:void(0)" 
       ngxSlickItem  
       (click)="filterItemsByCategory(category)" 
       class="ct-menu-category-item" 
       *ngFor="let category of categories"
       [class.active]="selectedCategory?.id === category.id">
        <div class="menu-category-thumb">
            <img [src]="category.img" alt="{{category.title}}">
        </div>
        <div class="menu-category-desc">
            <h6>{{category.title}}</h6>
        </div>
    </a>
</ngx-slick-carousel>
    </div>
</div>
<!-- Menu Categories End -->
<!-- Menu Wrapper Start -->
<div class="section section-padding">
    <div class="container">
        <div class="menu-container row">
            <!-- Product Start -->
            <div class="col-lg-4 col-md-6" *ngFor="let item of filteredItems">
                <div class="product">
                    <a class="product-thumb" routerLink="/menu-item-v1/{{item.id}}"> <img [src]="item.img"
                            alt="{{item.name}}" /> </a>
                    <div class="product-body">
                        <div class="product-desc">
                            <h4> <a routerLink="/menu-item-v1/{{item.id}}">{{item.name}}</a> </h4>
                            <p>{{item.shortdesc}}</p>
                            <!-- <p class="product-price">{{item.price | number:'1.2-2'}}$</p> -->
                            <div class="favorite">
                                <i class="far fa-heart"></i>
                            </div>
                        </div>
                        <div class="product-controls">
                            <a routerLink="/menu-item-v1/{{item.id}}" class="order-item btn-custom btn-sm shadow-none">Commander
                                <i class="fas fa-shopping-cart"></i> </a>
                            <!-- <button type="button" class="btn-custom secondary btn-sm shadow-none"
                                (click)="open(shopmodal, item)"> Customize <i class="fas fa-plus"></i> </button> -->
                        </div>
                    </div>
                </div>
            </div>
            <!-- Product End -->
        </div>
    </div>
</div>
<!-- Menu Wrapper End -->
<ng-template #shopmodal let-modal>
    <button type="button" class="close-btn" (click)="modal.dismiss('Cross click')">
        <span></span>
        <span></span> 
    </button>
    <div class="modal-header modal-bg" style="background-image: url('{{modalContent.img}}')">
        
    </div>
    <div class="modal-body">
        <div class="customize-meta">
            <h4 class="customize-title">{{modalContent.name}} <span class="custom-primary">{{modalContent.price |
                    number:'1.2-2'}}$</span> </h4>
            <p>{{modalContent.shortdesc}}</p>
        </div>
        <div class="customize-variations">
            <div class="customize-size-wrapper">
                <h5>Taille: </h5>
                <div class="customize-size" [ngClass]="item.state == true ? 'active' : ''" 
                    *ngFor="let item of modalContent.sizes">
                    {{item.size}}"
                </div>
            </div> 
            <div class="row">
                <!-- Variation Start -->
                <div class="col-lg-4 col-12" *ngFor="let item of modalContent.attributes | slice:0:3">
                    <div class="customize-variation-wrapper">
                        <i class="{{item.icon}}"></i>
                        <h5>{{item.name}}</h5>
                        <div class="customize-variation-item" *ngFor="let add of item.items">
                            <div class="custom-control custom-{{item.type}}">
                                <input type="{{item.type}}" id="{{add.title + 1}}" name="{{item.name}}" class="custom-control-input">
                                <label class="custom-control-label" for="{{add.title + 1}}">{{add.title}}</label>
                            </div>
                            <span>+{{add.addprice | number:'1.2-2'}}$</span>
                        </div>
                    </div>
                </div>
                <!-- Variation End -->
            </div>
        </div>
        <div class="customize-controls">
            <div class="qty">
                <span class="qty-subtract"><i class="fas fa-minus"></i></span>
                <input type="text" name="qty" value="1">
                <span class="qty-add"><i class="fas fa-plus"></i></span>
            </div>
            <div class="customize-total">
                <h5>Total Price: <span class="final-price custom-primary">{{modalContent.price | number:'1.2-2'}} <span>$</span> </span> </h5>
            </div>
        </div>
        <button type="button" class="btn-custom btn-block">Commander maintenant</button>
    </div>
</ng-template>

<app-footer [layout]="classname" [logo]="ftlogo"></app-footer>